export default __webpack_public_path__ + "7fd77b61e15c1db295174fe94d779dab.png";